import { useQuery } from 'react-query';

import { DocChronologySummary } from '../../../../backend/src/matter/subset/chronology/doc-chronology/dto/get-doc-chronologies-response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useGetDocChronologies = ({ matterId, subsetId }: { matterId: string; subsetId: string }) => {
  const fetcher = useFetcher();

  return useQuery<DocChronologySummary[]>(
    [QueryEntity.DocChronologies, { subsetId }],
    () => fetcher(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology`),
    { enabled: !!matterId && !!subsetId },
  );
};
